import { render, staticRenderFns } from "./payment-plan.vue?vue&type=template&id=15b2beb2&scoped=true"
import script from "./payment-plan.vue?vue&type=script&lang=js"
export * from "./payment-plan.vue?vue&type=script&lang=js"
import style0 from "./payment-plan.vue?vue&type=style&index=0&id=15b2beb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2beb2",
  null
  
)

export default component.exports